const steps = [
  {
    number: '01',
    icon: 'ri-file-text-line',
    title: 'Request a Quote',
    desc: 'Fill in our simple form or give us a call. We\'ll get back to you within 24 hours.',
    bg: 'bg-orange-50',
    iconColor: 'text-orange-500',
    badgeBg: 'bg-orange-500',
  },
  {
    number: '02',
    icon: 'ri-map-pin-user-line',
    title: 'Site Visit & Advice',
    desc: 'We visit your property, assess the work, and provide expert recommendations.',
    bg: 'bg-sky-50',
    iconColor: 'text-sky-500',
    badgeBg: 'bg-sky-500',
  },
  {
    number: '03',
    icon: 'ri-price-tag-3-line',
    title: 'Clear Pricing',
    desc: 'You receive a detailed, transparent quote with no hidden costs or surprises.',
    bg: 'bg-emerald-50',
    iconColor: 'text-emerald-500',
    badgeBg: 'bg-emerald-500',
  },
  {
    number: '04',
    icon: 'ri-brush-4-line',
    title: 'Professional Execution',
    desc: 'Our skilled team gets to work, delivering a clean and precise finish on time.',
    bg: 'bg-violet-50',
    iconColor: 'text-violet-500',
    badgeBg: 'bg-violet-500',
  },
  {
    number: '05',
    icon: 'ri-checkbox-circle-line',
    title: 'Final Inspection',
    desc: 'We walk through the completed work with you to ensure you\'re 100% satisfied.',
    bg: 'bg-amber-50',
    iconColor: 'text-amber-500',
    badgeBg: 'bg-amber-500',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">How It Works</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight mb-4">Our Simple Process</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            From first contact to final inspection — we make it easy every step of the way.
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-0.5 bg-[#E5E5E5]" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((step, i) => (
              <div key={step.number} className="relative flex flex-col items-center text-center">
                {/* Step circle */}
                <div className={`relative z-10 w-20 h-20 flex items-center justify-center rounded-full ${step.bg} border-4 border-white mb-5 flex-shrink-0`}>
                  <i className={`${step.icon} ${step.iconColor} text-2xl`} />
                  <div className={`absolute -top-1 -right-1 w-6 h-6 flex items-center justify-center rounded-full ${step.badgeBg} text-white text-xs font-black`}>
                    {i + 1}
                  </div>
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
